module.exports = __webpack_public_path__ + "img/bundle_initial.b8fc89bf.png";